export function defaultCellData() {
  return {
    value: '',
    bold: false, italic: false, underline: false, strike: false,
    fontFamily: 'Calibri', fontSize: 11,
    color: '#000000', bgColor: '',
    hAlign: 'general', vAlign: 'bottom',
    numberFormat: 'general',
    borderTop: false, borderBottom: false, borderLeft: false, borderRight: false,
    borderColor: '#000000', borderStyle: 'solid',
    borderTopStyle: 'solid', borderBottomStyle: 'solid',
    borderLeftStyle: 'solid', borderRightStyle: 'solid',
    borderTopColor: '#000000', borderBottomColor: '#000000',
    borderLeftColor: '#000000', borderRightColor: '#000000',
    borderTopWidth: 1, borderBottomWidth: 1,
    borderLeftWidth: 1, borderRightWidth: 1,
    diagTR: false, diagBL: false,
    diagColor: '#000000', diagStyle: 'solid', diagWidth: 1,
    wrapText: false,
    indent: 0,
    locked: false,
    comment: '',
  };
}
